export default {
  state: {
    drawerNdaOpen: false,
    currentDoc: null,
  },
  mutations: {
    SET_DRAWER_NDA_OPEN(state, drawerNdaOpen) {
      console.log('Inside SET_DRAWER_NDA_OPEN - drawerNdaOpen', drawerNdaOpen)
      state.drawerNdaOpen = drawerNdaOpen
    },
    SET_CURRENT_DOC(state, currentDoc) {
      console.log('Inside SET_CURRENT_DOC - currentDoc', currentDoc)
      state.currentDoc = currentDoc
    },
  },
  getters: {
    GET_DRAWER_NDA_OPEN(state) {
      return state.drawerNdaOpen
    },
    GET_CURRENT_DOC(state) {
      return state.currentDoc
    },
  },
}
